"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownActionTypes = void 0;
const DropdownActionTypes = exports.DropdownActionTypes = {
  blur: 'dropdown:blur',
  escapeKeyDown: 'dropdown:escapeKeyDown',
  toggle: 'dropdown:toggle',
  open: 'dropdown:open',
  close: 'dropdown:close'
};